module.exports = __webpack_public_path__ + "img/elementlengths_jaka.8904c3d8.png";